const colors  = [
    '#c23728',
    '#de6e56',
    '#ffffff',
    '#a7d5ed',
    '#22a7f0',
]


export default colors;